<section class="overview-page agent-tokens-page" data-testid="agent-tokens-page">
  @if (user(); as account) {
    <app-page-header
      [eyebrow]="'agentTokens.eyebrow' | translate"
      [title]="'agentTokens.title' | translate: { name: account.displayName }"
      [subtitle]="address()"
    >
      @if (isAgent()) {
        <app-ki-konto-pill titleAside />
      }
      <ng-container right>
        @if (isAgent()) {
          <button
            mat-flat-button
            type="button"
            class="agent-tokens-page__create"
            data-testid="agent-token-create"
            [disabled]="isInactive()"
            (click)="openCreateDialog()"
          >
            {{ 'agentTokens.create' | translate }}
          </button>
        }
      </ng-container>
    </app-page-header>

    @if (!isAgent()) {
      <p class="overview-page__hint" data-testid="agent-tokens-person-hint">
        {{ 'agentTokens.personHint' | translate }}
      </p>
    } @else {
      @if (isInactive()) {
        <p class="agent-tokens-page__inactive-hint" data-testid="agent-tokens-inactive-hint">
          {{ 'agentTokens.inactiveHint' | translate }}
        </p>
      }

      <section class="agent-tokens-page__card" [attr.aria-label]="'agentTokens.listLabel' | translate">
        @if (tokensLoading()) {
          <div class="agent-tokens-page__loading">
            <mat-progress-spinner mode="indeterminate" diameter="32" />
          </div>
        } @else if (tokensLoadFailed()) {
          <p class="agent-tokens-page__error" role="alert">{{ 'pat.loadError' | translate }}</p>
        } @else if (tokens().length === 0) {
          <p class="agent-tokens-page__empty">{{ 'pat.empty' | translate }}</p>
        } @else {
          <ul class="agent-tokens-page__list">
            @for (token of tokens(); track token.id) {
              <li class="agent-tokens-page__token">
                <div class="agent-tokens-page__token-main">
                  <span class="agent-tokens-page__token-name">{{ token.name }}</span>
                  <ul class="agent-tokens-page__token-scopes">
                    @for (scope of token.scopes; track scope) {
                      <li class="agent-tokens-page__token-scope">{{ 'pat.scope.' + scope | translate }}</li>
                    }
                  </ul>
                </div>
                <dl class="agent-tokens-page__token-meta">
                  <div class="agent-tokens-page__token-meta-item">
                    <dt>{{ 'pat.meta.expires' | translate }}</dt>
                    <dd>
                      {{ token.expiresAt ? (token.expiresAt | date: 'mediumDate') : ('pat.meta.noExpiry' | translate) }}
                    </dd>
                  </div>
                  <div class="agent-tokens-page__token-meta-item">
                    <dt>{{ 'pat.meta.lastUsed' | translate }}</dt>
                    <dd>
                      {{ token.lastUsedAt ? (token.lastUsedAt | date: 'short') : ('pat.meta.neverUsed' | translate) }}
                    </dd>
                  </div>
                </dl>
                <button
                  mat-icon-button
                  type="button"
                  class="agent-tokens-page__token-revoke"
                  [attr.aria-label]="'pat.revoke' | translate"
                  (click)="requestRevoke(token)"
                >
                  <mat-icon aria-hidden="true">delete_outline</mat-icon>
                </button>
              </li>
            }
          </ul>
        }
      </section>

      <app-pat-create-dialog
        [visible]="createDialogVisible()"
        [isBusy]="isCreatingToken()"
        [createdToken]="createdToken()"
        [scopesSource]="scopesSource"
        [expiryRequired]="true"
        (create)="onCreateToken($event)"
        (visibleChange)="onCreateDialogVisibleChange($event)"
      />

      <app-confirm-dialog
        [visible]="revokeTarget() !== null"
        [title]="'pat.revokeDialog.title' | translate"
        [message]="'pat.revokeDialog.message' | translate: { name: revokeTarget()?.name }"
        [confirmLabel]="'pat.revokeDialog.confirm' | translate"
        [cancelLabel]="'pat.revokeDialog.cancel' | translate"
        [busy]="isRevoking()"
        (confirmed)="confirmRevoke()"
        (cancelled)="cancelRevoke()"
      />
    }
  } @else if (userLoadFailed()) {
    <p class="overview-page__hint" role="alert">{{ 'agentTokens.userLoadError' | translate }}</p>
  } @else if (userLoading()) {
    <div class="overview-page__loading">
      <mat-progress-spinner mode="indeterminate" diameter="32" />
    </div>
  }
</section>
